import { callApi } from 'src/utils/apiCall';

const BASE = '/api/v1/reports/client-reports/';
export async function reportRequest(path, method = 'GET', body = null, options = {}) {
  const result = await callApi(`${BASE}${path}`, method, body, false, {
    suppressServerErrorDispatch: true,
    ...options,
  });
  if (!result.ok) {
    const detail = result.data?.detail;
    let message = 'Request failed. Please try again.';
    if (result.data && !(result.data instanceof Blob)) message = JSON.stringify(result.data);
    if (typeof detail === 'string') message = detail;
    if (result.status === 429)
      message = `Too many requests. ${
        result.retryAfter?.seconds ? `Try again in ${result.retryAfter.seconds} seconds.` : 'Please try again later.'
      }`;
    const error = new Error(message);
    error.status = result.status;
    throw error;
  }
  return result.data;
}
export async function downloadArtifact(runId, artifact, isCurrent, signal) {
  // Reconstruct a trusted API path. Never send credentials to a returned storage URL.
  const blob = await reportRequest(
    `runs/${encodeURIComponent(runId)}/artifacts/${encodeURIComponent(artifact.id)}/download/`,
    'GET',
    null,
    { responseType: 'blob', signal }
  );
  if (!isCurrent()) return;
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = artifact.filename || `report.${artifact.format === 'EXCEL' ? 'xlsx' : 'pdf'}`;
  document.body.appendChild(link);
  try {
    link.click();
  } finally {
    link.remove();
    URL.revokeObjectURL(url);
  }
}
